/*****************************************************************************
 *   © Copyright 2021   Quantitative Software Management, Inc.               *
 *              --  All rights reserved.  --                                 *
 *   Unpublished -- rights reserved under the Copyright Laws                 *
 *   of the United States.                                                   *
 *                                                                           *
 *   This computer software is protected by trade secret, copyright law,     *
 *   and international treaties and contains proprietary and confidential    *
 *   trade secrets of Quantitative Software Management, Inc.  Unauthorized   *
 *   use, reproduction, or distribution of this program or any portion of    *
 *   it will result in severe civil or criminal penalties and will be        *
 *   prosecuted to the full extent of the law.                               *
 *                                                                           *
 *   Use, duplication, or disclosure by the Government is subject to         *
 *   restrictions as set forth in                                            *
 *      (i) a license agreement incorporated in the contract,                *
 *      (ii) the definition of "restricted rights" in paragraph (c)(1)(ii)   *
 *           of DFARS 252.227-7013 (1988), and                               *
 *      (iii) the definition of "restricted rights" in paragraph (a) of      *
 *            FAR 52.227-14, Alt III (Jun 1987) or                           *
 *      (iv) FAR 52.227-19 (Jun 1987), as applicable.                        *
 *   For purposes of the FAR, this software shall be deemed to               *
 *   be "unpublished" and licensed with disclosure prohibitions.             *
 *   Contractor/Manufacturer is   Quantitative Software Management, Inc.     *
 *                                                                           *
 *****************************************************************************/

import { Location } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppConstants } from '../../app.constants';
import { LoadingService } from '../../services/loading.service';
import { UtilityService } from '../../services/Utility.Service';


@Component({
  selector: 'app-embed-page',
  templateUrl: './embed-page.component.html',
  styleUrls: ['./embed-page.component.css']
})
export class EmbedPageComponent implements OnInit, OnDestroy {

  public iFrameHeight;
  @ViewChild('iframe', {
    static: false
  }) theIframe: ElementRef<HTMLIFrameElement>;

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    this.utilService.SetWebPagePopIn(false).subscribe();    
  }

  constructor(private route: ActivatedRoute, private sanitizer: DomSanitizer, private titleService: Title,
    private loadingService: LoadingService, private location: Location, private utilService: UtilityService) { }

  public iframeLoad(e) {
    try {
      let iframeHref = this.theIframe?.nativeElement.contentWindow.location.href;
      // throws exception on cross-origin error
      let relativeHref: string = this.utilService.RelativeUrl(iframeHref);
      if (relativeHref) {  //excludes "about:blank"
        //set height and title
        this.iFrameHeight = Math.max(this.theIframe?.nativeElement.contentWindow.document.body.clientHeight + 30, 690);
        this.titleService.setTitle(this.theIframe?.nativeElement.contentWindow.document.title);
        //check whether to synchronize router
        if (this.IsAspx(iframeHref)) {  //if not, router doesn't matter, it will pop out
          let snapshotAspxpath = this.utilService.RelativeUrl(this.route.snapshot.queryParams["aspxpath"]);
          if (relativeHref !== snapshotAspxpath) {
            //let queryIndex = relativeHref.indexOf("?");
            //if (queryIndex >= 0) {
            //  relativeHref = relativeHref.substr(0, queryIndex);
            //}
            this.utilService.router.navigate(['/page'],
              {
                replaceUrl: true,
                queryParams: { aspxpath: relativeHref },
                state: { fromFrameLoad: true }
              });
          }
          this.loadingService.ShowLoading.next(false);
        }
        else {
          this.loadingService.ShowLoading.next(true);
        }
      }
    }
    catch (theError) {
      this.iFrameHeight = 0;  //avoids flash of page with error
      throw theError;
    }
  }

  IsAspx(theString: string): boolean {
    let ok = true;
    try {
      let theirUrl: URL = new URL(theString);
      ok = theirUrl.host.toLowerCase() == window.location.host.toLowerCase();
    }
    catch { }
    if (ok) {  //host name is ok or is relative
      let relUrl = this.utilService.RelativeUrl(theString);
      if (relUrl) {
        relUrl = relUrl.toLowerCase();
        let queryIndex = relUrl.indexOf("?");
        if (queryIndex >= 0) {
          relUrl = relUrl.substr(0, queryIndex);
        }
        ok = relUrl.startsWith(`/${AppConstants.WEBAPP_NAME}`) && relUrl.endsWith(".aspx");
      }
      else {
        throw new Error("Attempt to load invalid URL: " + theString);
      }
    }
    else {
      throw new Error("Attempt to load URL from another Host: " + theString);
    }
    return ok;
  }
  private subscriptions: Subscription = new Subscription();
  ngOnInit(): void {
    let source = this.route.snapshot.queryParams["aspxpath"];
    this.subscriptions.add(this.utilService.SetWebPagePopIn(true).subscribe(x => {
      this.subscriptions.add(this.route.queryParams.subscribe(parm => {
        if (parm.aspxpath) {
          if (this.IsAspx(parm.aspxpath)) {
            if (!(this.utilService.router.getCurrentNavigation()?.extras?.state?.fromFrameLoad)) {//check for absence of the flag passed when "load before route"
              if (this.theIframe) {
                this.theIframe.nativeElement.contentWindow.location.replace(parm.aspxpath); //because of "replace", the "load" part won't write a history record
              }
            }
            else {
              this.loadingService.ShowLoading.next(false); //needed cause app component turns it off when url changed
            }
          }
          else {
            throw new Error("Attempt to load incorrect URL: " + parm.aspxpath);
          }
        }
        else {
          this.utilService.router.navigate(['/page'],
            {
              queryParams: { aspxpath: "/qsmweb/Views/Services/Portfolio/Portfolio_Default.aspx" }
            });
        }
      }));
    }));
    if (!source) {
      this.utilService.router.navigate(['/page'],
        {
          queryParams: { aspxpath: "/qsmweb/Views/Services/Portfolio/Portfolio_Default.aspx" }
        });
    }

  }
  ngOnDestroy(): void {
    this.utilService.SetWebPagePopIn(false).subscribe();    
    this.subscriptions.unsubscribe();    
  }
}
